export default [
  {
    title: "Ana Sayfa",
    to: { name: "root" },
    icon: { icon: "tabler-smart-home" },
    yetki: {},
  },
  {
    title: "Kullanıcılar",
    to: { name: "kullanicilar" },
    icon: { icon: "tabler-users-group" },
    yetki: { k: [1000002] },
  },
  {
    title: "Hızlı Satış",
    to: { name: "satishizli" },
    icon: { icon: "tabler-receipt-2" },
    yetki: { k: [1030808] },
  },
  {
    title: "Hızlı Ödeme",
    to: { name: "odemehizli" },
    icon: { icon: "tabler-cash" },
    yetki: { k: [1040508] },
  },
  {
    title: "Öğrenci",
    to: { name: "ogrenci" },
    icon: { icon: "tabler-users" },
    yetki: { k: [1019102] },
  },
  {
    title: "Etkinlik",
    to: { name: "etkinlik" },
    icon: { icon: "tabler-trekking" },
    yetki: { k: [1010002] },
  },
  {
    title: "Tüm Takimlar",
    to: { name: "sinif_tanitim" },
    icon: { icon: "tabler-olympics" },
    yetki: { k: [1017002] },
  },
  {
    title: "Yoklama",
    to: { name: "yoklama" },
    icon: { icon: "tabler-user-check" },
    yetki: { k: [1111002] },
  },
  {
    title: "Takımlar",
    to: { name: "takimlar" },
    icon: { icon: "tabler-users-group" },
    yetki: { e: true },
  },
  {
    title: "Envanter",
    to: { name: "envanter" },
    icon: { icon: "tabler-building-warehouse" },
    yetki: { k: [1015002] },
  },
  {
    title: "Stok",
    icon: { icon: "fluent-mdl2--product-variant" },
    yetki: {
      k: [
        1030802, 1030302, 1030402, 1030502, 1030602, 1030102, 1030202, 1030702,
        1030902,
      ],
    },
    children: [
      {
        title: "Satış",
        to: { name: "satis" },
        icon: { icon: "fluent-mdl2--product-variant" },
        yetki: { k: [1030802] },
      },
      // {
      //   title: "Proforma",
      //   to: { name: "proforma" },
      //   icon: { icon: "fluent-mdl2--product-variant" },
      //   yetki: { k: [1031002] },
      // },
      {
        title: "Stok Giriş",
        to: { name: "stokgiris" },
        icon: { icon: "fluent-mdl2--product-variant" },
        yetki: { k: [1030302] },
      },
      {
        title: "Stok Çıkış",
        to: { name: "stokcikis" },
        icon: { icon: "fluent-mdl2--product-variant" },
        yetki: { k: [1030402] },
      },
      {
        title: "Depo Transfer",
        to: { name: "depolararasi" },
        icon: { icon: "fluent-mdl2--product-variant" },
        yetki: { k: [1030502] },
      },
      {
        title: "Stok Sayımları",
        to: { name: "deposayim" },
        icon: { icon: "fluent-mdl2--product-variant" },
        yetki: { k: [1030602] },
      },
      // {
      //   title: "Raporlar",
      //   icon: { icon: "fluent-mdl2--product-variant" },
      //   yetki: {
      //     k: [1110002],
      //   },
      //   children: [
      //     {
      //       title: "Öğrenci Borç",
      //       to: { name: "ogrenci_borc" },
      //       icon: { icon: "fluent-mdl2--product-variant" },
      //       yetki: { k: [1110002] },
      //     },
      //     //     {
      //     //       title: "Depo Stok Miktarları",
      //     //       to: { name: "stokdepo" },
      //     //       icon: { icon: "fluent-mdl2--product-variant" },
      //     //       // yetki: { k: [1020002] },
      //     //     },
      //     //     {
      //     //       title: "Stok Ekstresi",
      //     //       to: { name: "stokdepo" },
      //     //       icon: { icon: "fluent-mdl2--product-variant" },
      //     //       // yetki: { k: [1020002] },
      //     //     },
      //     //     // {
      //     //     //   title: "Stok Hareketleri",
      //     //     //   to: { name: "stokdepo" },
      //     //     //   icon: { icon: "fluent-mdl2--product-variant" },
      //     //     //   // yetki: { k: [1020002] },
      //     //     // },
      //   ],
      // },
      {
        title: "Stok Tanıtım",
        icon: { icon: "fluent-mdl2--product-variant" },
        yetki: { k: [1030102, 1030202, 1030702, 1030902] },
        children: [
          {
            title: "Stok Kartı",
            to: { name: "stokkarti" },
            icon: { icon: "fluent-mdl2--product-variant" },
            yetki: { k: [1030202] },
          },
          {
            title: "Depo",
            to: { name: "stokdepo" },
            icon: { icon: "fluent-mdl2--product-variant" },
            yetki: { k: [1030102] },
          },
          {
            title: "Stok Group",
            to: { name: "stokgroup" },
            icon: { icon: "fluent-mdl2--product-variant" },
            yetki: { k: [1030702] },
          },
          {
            title: "İndirim",
            to: { name: "indirim" },
            icon: { icon: "fluent-mdl2--product-variant" },
            yetki: { k: [1030902] },
          },
        ],
      },
    ],
  },
  {
    title: "Kasa",
    icon: { icon: "fluent-mdl2--product-variant" },
    yetki: {
      k: [1040002, 1040202, 1040302, 1040402, 1040002, 1040602],
    },
    children: [
      {
        title: "Para Giriş",
        to: { name: "kasagiris" },
        icon: { icon: "fluent-mdl2--product-variant" },
        yetki: { k: [1040102] },
      },
      {
        title: "Para Çıkış",
        to: { name: "kasacikis" },
        icon: { icon: "fluent-mdl2--product-variant" },
        yetki: { k: [1040202] },
      },
      {
        title: "Kasa Virman",
        to: { name: "kasavirman" },
        icon: { icon: "fluent-mdl2--product-variant" },
        yetki: { k: [1040702] },
      },
      {
        title: "Bakiye Görüntüle",
        to: { name: "caribakiye" },
        icon: { icon: "fluent-mdl2--product-variant" },
        yetki: { k: [1040302] },
      },
      {
        title: "Kasa Durum",
        to: { name: "kasadurum" },
        icon: { icon: "fluent-mdl2--product-variant" },
        yetki: { k: [1040402] },
      },
      {
        title: "Kasa Tanıtım",
        to: { name: "kasa" },
        icon: { icon: "fluent-mdl2--product-variant" },
        yetki: { k: [1040002] },
      },
      {
        title: "Excel Banka Giriş",
        to: { name: "excel_banka" },
        icon: { icon: "fluent-mdl2--product-variant" },
        yetki: { k: [1040602] },
      },
    ],
  },
  {
    title: "Raporlar",
    icon: { icon: "fluent-mdl2--product-variant" },
    yetki: {
      k: [1110002],
    },
    children: [
      {
        title: "Öğrenci Borç",
        to: { name: "ogrenci_borc" },
        icon: { icon: "fluent-mdl2--product-variant" },
        yetki: { k: [1110002] },
      },
      {
        title: "Eğitmen Ders Devam",
        to: { name: "rapor_egitmen_ders_devam" },
        icon: { icon: "fluent-mdl2--product-variant" },
        yetki: { k: [1112002] },
      },
      {
        title: "Öğrenci Ders Devam",
        to: { name: "rapor_ogrenci_ders_devam" },
        icon: { icon: "fluent-mdl2--product-variant" },
        yetki: { k: [1113002] },
      },
      //     {
      //       title: "Depo Stok Miktarları",
      //       to: { name: "stokdepo" },
      //       icon: { icon: "fluent-mdl2--product-variant" },
      //       // yetki: { k: [1020002] },
      //     },
      //     {
      //       title: "Stok Ekstresi",
      //       to: { name: "stokdepo" },
      //       icon: { icon: "fluent-mdl2--product-variant" },
      //       // yetki: { k: [1020002] },
      //     },
      //     // {
      //     //   title: "Stok Hareketleri",
      //     //   to: { name: "stokdepo" },
      //     //   icon: { icon: "fluent-mdl2--product-variant" },
      //     //   // yetki: { k: [1020002] },
      //     // },
    ],
  },
  {
    title: "Tanıtım",
    icon: { icon: "fluent-mdl2--product-variant" },
    yetki: { k: [1020002, 1020102, 1020602, 1020902, 1017008] },
    children: [
      {
        title: "Şube",
        to: { name: "sube_tanitim" },
        icon: { icon: "fluent-mdl2--product-variant" },
        yetki: { k: [1020002] },
      },
      {
        title: "Spor Dalı",
        to: { name: "spordali_tanitim" },
        icon: { icon: "fluent-mdl2--product-variant" },
        yetki: { k: [1020102] },
      },
      {
        title: "Eğitim Türü",
        to: { name: "egitimturu_tanitim" },
        icon: { icon: "fluent-mdl2--product-variant" },
        yetki: { k: [1020602] },
      },
      {
        title: "Varsayilan Fiyat",
        to: { name: "varsayilan_fiyat" },
        icon: { icon: "fluent-mdl2--product-variant" },
        yetki: { k: [1017008] },
      },

      {
        title: "Parametre",
        to: { name: "parametre" },
        icon: { icon: "tabler-settings" },
        yetki: { k: [1020902] },
      },
      // {
      //   title: "Level 2.2",
      //   children: [
      //     {
      //       title: "Level 3.1",
      //       to: null,
      //     },
      //     {
      //       title: "Level 3.2",
      //       to: null,
      //     },
      //   ],
      // },
    ],
  },
  {
    title: "Programcı",
    icon: { icon: "tabler-user-cog" },
    yetki: { p: true },
    children: [
      {
        title: "Laravel Log",
        to: { name: "laravel_log" },
        icon: { icon: "fluent-mdl2--product-variant" },
      },
      // {
      //   title: "ScheduleMonitor",
      //   to: { name: "ScheduleMonitor" },
      //   icon: { icon: "fluent-mdl2--product-variant" },
      // },

      // {
      //   title: "Level 2.2",
      //   children: [
      //     {
      //       title: "Level 3.1",
      //       to: null,
      //     },
      //     {
      //       title: "Level 3.2",
      //       to: null,
      //     },
      //   ],
      // },
    ],
  },
  {
    title: "Çıkış",
    to: { name: "logout" },
    icon: { icon: "tabler-logout" },
  },
];
